// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiCopay {
    static getAttributeTypeMap() {
        return MedicalBiCopay.attributeTypeMap;
    }
}
MedicalBiCopay.discriminator = undefined;
MedicalBiCopay.additionalProperties = false;
MedicalBiCopay.attributeTypeMap = [
    {
        "name": "appliesToOop",
        "baseName": "appliesToOop",
        "type": "string"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "string"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "string"
    },
    {
        "name": "waivedAfterOop",
        "baseName": "waivedAfterOop",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalBiCopay.js.map